import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';
import { Select } from '@sopranodesign/pulse-components';

const getMethodName = ({ name, endpoint, method }) => {
  if (name) {
    return name;
  }

  return `${method.toUpperCase()} ${endpoint}`;
};

const format = method => ({
  value: method.id,
  label: getMethodName(method)
});

const EndpointSelect = ({
  value,
  integration,
  currentlySelected,
  ...props
}) => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'integrations'
    ]
  });

  const disabled = !integration;

  const endpoints = useMemo(() => {
    if (!integration || !isSuccess) {
      return null;
    }

    return data.data.find(({ id }) => id === integration).endpoints;
  }, [data, isSuccess, integration]);

  const endpoint = () => {
    if (!endpoints || !value) {
      return null;
    }

    const endpoint = endpoints.find(endpoint => endpoint.id === value);

    if (!endpoint) {
      return null;
    }

    return format(endpoint);
  };

  const filterEndpoints = () => {
    return endpoints.filter(
      item =>
        !currentlySelected?.some(
          selected =>
            selected.base.integration_id === item.integration_id &&
            selected.base.id === item.id
        )
    );
  };

  return (
    <Select
      isLoading={isLoading}
      isDisabled={disabled}
      placeholder={'/users'}
      options={endpoints ? filterEndpoints().map(format) : []}
      value={endpoint()}
      {...props}
    />
  );
};

EndpointSelect.propTypes = {
  value: PropTypes.number,
  integration: PropTypes.number,
  currentlySelected: PropTypes.object
};

export default EndpointSelect;
